<template>
  <div class="origin">
      <div class="container">
        <div class="title">{{ $t('origin.titulo') }}</div>
        <div v-html="$t('origin.descripcion')" class="content"></div>
      </div>
      <div class="container-slider">
        <div class="container">
          <div class="carousel">
            <div v-show="actual === 1 || closing === 1" :class="{'showed': actual === 1, 'closing': closing === 1 }" class="quote">
              <div>
                <div class="text"><i class="fas fa-quote-left"></i> {{$t('origin.slider[0].texto')}}</div>
                <div class="autor"><i class="far fa-horizontal-rule"></i> {{$t('origin.slider[0].autor')}}</div>
              </div>
            </div>
            <div v-show="actual === 2 || closing === 2" :class="{'showed': actual === 2, 'closing': closing === 2 }" class="quote">
              <div>
                <div class="text"><i class="fas fa-quote-left"></i> {{$t('origin.slider[1].texto')}}</div>
                <div class="autor"><i class="far fa-horizontal-rule"></i> {{$t('origin.slider[1].autor')}}</div>
              </div>
            </div>
            <div v-show="actual === 3 || closing === 3" :class="{'showed': actual === 3, 'closing': closing === 3 }" class="quote">
              <div>
                <div class="text"><i class="fas fa-quote-left"></i> {{$t('origin.slider[2].texto')}}</div>
                <div class="autor"><i class="far fa-horizontal-rule"></i> {{$t('origin.slider[2].autor')}}</div>
              </div>
            </div>
            <div v-show="actual === 4 || closing === 4" :class="{'showed': actual === 4, 'closing': closing === 4 }" class="quote">
              <div>
                <div class="text"><i class="fas fa-quote-left"></i> {{$t('origin.slider[3].texto')}}</div>
                <div class="autor"><i class="far fa-horizontal-rule"></i> {{$t('origin.slider[3].autor')}}</div>
              </div>
            </div>
            <div v-show="actual === 5 || closing === 5" :class="{'showed': actual === 5, 'closing': closing === 5 }" class="quote">
              <div>
                <div class="text"><i class="fas fa-quote-left"></i> {{$t('origin.slider[4].texto')}}</div>
                <div class="autor"><i class="far fa-horizontal-rule"></i> {{$t('origin.slider[4].autor')}}</div>
              </div>
            </div>
            <div v-show="actual === 6 || closing === 6" :class="{'showed': actual === 6, 'closing': closing === 6 }" class="quote">
              <div>
                <div class="text"><i class="fas fa-quote-left"></i> {{$t('origin.slider[5].texto')}}</div>
                <div class="autor"><i class="far fa-horizontal-rule"></i> {{$t('origin.slider[5].autor')}}</div>
              </div>
            </div>
            <div v-show="actual === 7 || closing === 7" :class="{'showed': actual === 7, 'closing': closing === 7 }" class="quote">
              <div>
                <div class="text"><i class="fas fa-quote-left"></i> {{$t('origin.slider[6].texto')}}</div>
                <div class="autor"><i class="far fa-horizontal-rule"></i> {{$t('origin.slider[6].autor')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Origin',
  data: () => ({
    actual: 1,
    closing: 0,
    lengthSlider: 7,
    fnInterval: {}
  }),
  created () {
    this.asyncLoop()
  },
  methods: {
    asyncLoop () {
      const { lengthSlider } = this
      this.fnInterval = setInterval(() => {
        let saved = false
        if (this.actual < lengthSlider && !saved) {
          this.changeVisibleBlock(this.actual + 1)
          saved = true
        }
        if (this.actual === lengthSlider && !saved) {
          this.changeVisibleBlock(1)
          saved = true
        }
      }, 8000)
    },
    changeVisibleBlock (block) {
      clearInterval(this.fnInterval)
      this.asyncLoop()
      this.closing = this.actual
      setTimeout(() => {
        this.actual = block
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.origin {
  position: relative;
  width: 100%;
  background: url(../assets/bg-origin.png) no-repeat center center;
  background-size: cover;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 60px;
    padding-bottom: 50px;

    > div {
      width: 100%;
    }

    .title {
      margin-bottom: 60px;
      font-weight: 700;
      font-size: 36px;
      color: #444D67;
    }

    .content {
      font-size: 16px;
      max-width: 750px;
      margin: 0 auto;
      line-height: 170%;
      color: #6e6e6e;
    }
  }

  .container-slider {
    width: 100%;
    background: rgba(187, 217, 245, 0.25);
    overflow: hidden;

    .container {
      padding-top: 30px;
      padding-bottom: 30px;

      .carousel {
        position: relative;
        height: 210px;
        display: flex;
        justify-content: center;

        .quote {
          position: absolute;
          opacity: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .text,
          .autor {
            position: relative;
            font-size: 24px;
            color: #3A5366;

            i {
              position: absolute;
              top: -4px;
              left: -30px;
              color: #4AC4D0;
            }
          }

          .autor {
            margin-top: 15px;
            font-weight: 700;
            color: rgba(59, 84, 103, 0.4);
            align-self: flex-end;

            i {
              position: relative;
              top: 0;
              left: 0;
              margin-top: 0px;
              color: rgba(59, 84, 103, 0.4);
            }
          }

          &.showed {
            opacity: 0;
            left: 50%;
            animation: showQuote 0.4s 0s ease-in forwards;
          }

          &.closing {
            opacity: 1;
            left: 0;
            animation: hideQuote 0.4s 0s ease-in forwards;
          }

          @keyframes showQuote {
            from {
              opacity: 0;
              left: 50%;
            }
            to {
              opacity: 1;
              left: 0;
            }
          }

          @keyframes hideQuote {
            from {
              opacity: 1;
              left: 0;
            }
            to {
              opacity: 0;
              left: -50%;
            }
          }
        }
      }
    }
  }
}

@media(max-width: 1200px) {
  .origin {
    font-size: 14px;

    .container .content {
      font-size: 14px;
    }
  }
}

@media(max-width: 1150px) {
  .origin {
    font-size: 14px;
    .container .title {
      font-size: 32px;
      margin-bottom: 50px;
    }

    .container-slider .container .carousel .quote {
      .text,
      .autor {
        font-size: 20px;
      }
    }
  }
}

@media(max-width: 900px) {
  .origin {
    .container {
      padding-bottom: 80px;

      .title {
        font-size: 28px;
        margin-bottom: 40px;
      }
    }
  }
}

@media(max-width: 770px) {
  .origin {
    .container {
      padding-bottom: 40px;
    }

    .container-slider .container .carousel .quote {
      .text,
      .autor {
        font-size: 17px;
      }
    }
  }
}

@media(max-width: 500px) {
  .origin .container-slider .container .carousel .quote {
    .text i {
      left: -25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/origin.vue